import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastrService } from 'ngx-toastr';

@Directive({
  selector: '[ssCopy]',
  standalone: false
})
export class CopyDirective {
  @Input('ssCopy') value = '';
  @Input() copySuccess = 'Copiado';
  @Output() copied = new EventEmitter<boolean>();

  private copying = false;

  constructor(private clipboard: Clipboard, private toastr: ToastrService) { }

  @HostListener('click')
  async copy() {
    if (this.copying) return;

    this.copying = true;
    const success = await this.writeText(this.value);
    this.copying = false;

    if (success) {
      this.toastr.success(this.copySuccess);
    } else {
      this.toastr.error('Não foi possível copiar. Tente novamente.');
    }
    this.copied.emit(success);
  }

  private async writeText(value: string): Promise<boolean> {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(value);
        return true;
      }
    } catch {
    }
    return this.clipboard.copy(value);
  }
}
